import { ElementRef, OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'twoDecimalPlaces',
  standalone: true
})
export class TwoDecimalPlacesPipe implements PipeTransform, OnDestroy {
  private elementRef = inject(ElementRef);

  private boundBlurFunc: () => void;

  transform(value: number | string): string {
    if (this.elementRef.nativeElement === document.activeElement) {
      this.subscribeOnBlur();
      return value as string;
    }

    return this.formatInput(value);
  }

  ngOnDestroy(): void {
    if (this.boundBlurFunc) {
      const element = this.elementRef.nativeElement as HTMLInputElement;
      element.removeEventListener('blur', this.boundBlurFunc);
    }
  }

  private subscribeOnBlur(): void {
    if (!this.boundBlurFunc) {
      this.boundBlurFunc = this.onBlur.bind(this);
      const element = this.elementRef.nativeElement as HTMLInputElement;
      element.addEventListener('blur', this.boundBlurFunc);
    }
  }

  private onBlur(): void {
    const element = this.elementRef.nativeElement as HTMLInputElement;
    element.value = this.formatInput(element.value);
  }

  private formatInput(value: number | string): string {
    if ([null, undefined, ''].includes(value as string)) {
      return '';
    }

    if (typeof value === 'string') {
      return parseFloat(value).toFixed(2);
    }
    return value.toFixed(2);
  }
}
